import { AbstractControl, ValidationErrors } from "@angular/forms";

export const phoneNumberValidator = (control: AbstractControl): ValidationErrors | null => {
  const phoneNumber = control.value;
  return /^((\+|00(\s|\s?-\s?)?)31(\s|\s?-\s?)?(\(0\)[-\s]?)?|0)[1-9]((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/.test(
    phoneNumber,
  )
    ? null
    : { phoneNumber };
};
